import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#fa4d09",
        lightprimary: "#fc763e",
        secondary: "#04a6e1",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
        colorblue: "#8cd6e1",
        colorbeige: "#ebd6bc",
        coloryellow: "#ffd780",
        colorgrey: "#b7b7b7",
        colororange: "#ffaf71",
        colorgreen: "#92dd99",
        colorgreener: "#79b77f",
        colorpink: "#cc6c9c",
        colorlightpink: "#ffb2b7",
      },
    },
  },
});
